/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

export const levels =
  [
    {
      name: 'level1',
      ground: [100, 100],
      ball: {
        start: [80, 10],
        direction: [0.4, 1],
        radius: 5,
        endtime: 4, // in seconds
        enddistance: 200, // in scene units
      },
      goal: {
        position: [20, 80],
        radius: 8,
      },
      elements:
        [
          {
            type: 'box',
            from: [0, 0],
            to: [100, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 0],
            to: [100, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [100, 0],
            to: [100, 100],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [100, 100],
            to: [0, 100],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 100],
            to: [0, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'circle',
            center: [50, 50],
            radius: 10,
            specialty: 'fire',
          },
        ],
    },
    {
      name: 'level2',
      ground: [100, 100],
      ball: {
        start: [80, 10],
        direction: [0, 1],
        radius: 5,
        endtime: 4, // in seconds
        enddistance: 200, // in scene units
      },
      goal: {
        position: [20, 80],
        radius: 8,
      },
      elements:
        [
          {
            type: 'box',
            from: [97, 97],
            to: [55, 55],
            width: 3,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 0],
            to: [100, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 0],
            to: [100, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [100, 0],
            to: [100, 100],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [100, 100],
            to: [0, 100],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 100],
            to: [0, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'circle',
            center: [50, 50],
            radius: 10,
            specialty: 'fire',
          },
        ],
    },
    {
      name: 'level3',
      ground: [100, 100],
      ball: {
        start: [80, 10],
        direction: [0, 1],
        radius: 5,
        endtime: 4, // in seconds
        enddistance: 200, // in scene units
      },
      goal: {
        position: [20, 20],
        radius: 7,
      },
      elements:
        [
          {
            type: 'box',
            from: [50, 0],
            to: [50, 40],
            width: 3,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 0],
            to: [100, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 0],
            to: [100, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [100, 0],
            to: [100, 100],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [100, 100],
            to: [0, 100],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 100],
            to: [0, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'circle',
            center: [50, 50],
            radius: 10,
            specialty: 'fire',
          },
        ],
    },
    {
      name: 'level4',
      ground: [100, 100],
      ball: {
        start: [80, 10],
        direction: [-1, 0.1],
        radius: 5,
        endtime: 4, // in seconds
        enddistance: 200, // in scene units
      },
      goal: {
        position: [50, 50],
        radius: 7,
      },
      elements:
        [
          {
            type: 'box',
            from: [100, 33],
            to: [33, 33],
            width: 3,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [33, 33],
            to: [33, 66],
            width: 3,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 0],
            to: [100, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 0],
            to: [100, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [100, 0],
            to: [100, 100],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [100, 100],
            to: [0, 100],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 100],
            to: [0, 0],
            width: 2,
            specialty: 'norm',
          },
        ],
    },
    {
      name: 'level5',
      ground: [100, 100],
      ball: {
        start: [80, 10],
        direction: [-1, - 0.3],
        radius: 5,
        endtime: 4, // in seconds
        enddistance: 280, // in scene units
      },
      goal: {
        position: [50, 50],
        radius: 7,
      },
      elements:
        [
          {
            type: 'box',
            from: [100, 33],
            to: [33, 33],
            width: 3,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [33, 33],
            to: [33, 66],
            width: 3,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [33, 66],
            to: [55, 66],
            width: 3,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 0],
            to: [100, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 0],
            to: [100, 0],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [100, 0],
            to: [100, 100],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [100, 100],
            to: [0, 100],
            width: 2,
            specialty: 'norm',
          },
          {
            type: 'box',
            from: [0, 100],
            to: [0, 0],
            width: 2,
            specialty: 'norm',
          },
        ],
    },
  ];
